<script lang="ts">
  let props = $props()
  let { answer } = props
</script>

<div
  class="lg:ml-8 mt-2 border-l-2 border-dashed border-blue-800 px-4 lg:px-6 py-3 lg:py-6 bg-sky-50 rounded-r"
>
  {#if answer == 1}
    <p class="text-base lg:text-xl/8 text-gray-700">
      A: <span class="font-bold"
        >“Teammates lean in with support and step up where needed.”
      </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This reflects <span class="font-bold"
        >emotional trust, safety, and peer-level accountability.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      Your team supports people - without drama or avoidance.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Fast Attack crews care deeply for their people - not because it’s nice,
      but because cohesion under pressure is mission-critical.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Reinforce the norm: <span class="italic"
        >We step up for each other - and it makes us stronger.
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Then create rituals or check-ins that support wellness and humanity, not
      just output.
    </p>
  {:else if answer == 2}
    <p class="text-base lg:text-xl/8 text-gray-700">
      B: <span class="font-bold"
        >“People are kind but unsure how to respond.”
      </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This shows <span class="font-bold">empathy without structure.</span>
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      Your team cares - but hasn’t built the muscle for support in hard moments.
    </p>

    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Compassion is valuable, but unchanneled concern can turn into silence. On
      submarines, emotional fitness is part of operational fitness.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Offer language or frameworks: <span class="italic"
        >“Here’s how we support a teammate going through something.”</span
      >
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Model what it looks like to be available - and ask for help.
    </p>
  {:else if answer == 3}
    <p class="text-base lg:text-xl/8 text-gray-700">
      C: <span class="font-bold"
        >“It gets brushed aside and the pace keeps going.”
      </span>
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is a <span class="font-bold"
        >disconnect between values and action.</span
      >
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      Your culture may say “people first,” but behavior says “results only.”
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      Elite crews never ignore personal breakdowns - because performance suffers
      when people are left behind.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Create space. Ask your team: <span class="italic"
        >“What would make you feel safe sharing something tough?”
      </span>
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      Then build that into how you lead - not just how you talk.
    </p>
  {:else if answer == 4}
    <p class="text-base lg:text-xl/8 text-gray-700">
      D: <span class="font-bold"
        >“You don’t hear about it until it’s already affecting performance.”</span
      >
    </p>
    <p class="mt-4 text-sm lg:text-base/8 text-gray-700">
      This is a breakdown in trust and safety.
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700">
      People are suffering in silence - and no one feels safe enough to say
      something until it’s too late.
    </p>
    <p
      class="mt-2 text-sm lg:text-base/8 text-gray-700 px-0 lg:px-10 italic font-semibold"
    >
      On a submarine, silence like this would be catastrophic. Early signs are
      everything.
    </p>

    <p class="mt-6 text-base lg:text-lg/8 text-gray-700 font-bold">
      Level-Up Opportunity
    </p>
    <p class="mt-2 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4">
      Start with vulnerability at the top. Share your own tough moments - and
      invite others to do the same.
    </p>
    <p
      class="mt-1 text-sm lg:text-base/8 text-gray-700 ml-0 lg:ml-4 font-semibold"
    >
      If the captain never flinches, the crew won’t either - until the damage is
      done.
    </p>
  {/if}
</div>
